import React from 'react';
import {
    ListSubheader,
    MenuItem,
    Select,
} from "@mui/material";

const LocationSelect = ({ locations, groups, locationId, handleLocationChange }) => {

    const groupEntries = (group, level) => {

        let groupLocations = locations.filter(x => x.locationGroupId === group?.id);

        if (groupLocations.length === 0 && !group?.children?.length)
            return null;

        let entries = [];

        if (level > -1)
            entries.push(<ListSubheader style={{ marginLeft: `${level * 10}px` }}>{group?.name || "Not in a group"}</ListSubheader>);       

        entries.push(groupLocations.map(l => <MenuItem style={{ marginLeft: `${(level + 1) * 10}px` }} key={l.id} value={l.id}>{l.name} </MenuItem>));
        if (group?.children)
            entries.push(group.children.map(g => groupEntries(g, level + 1)))

        return entries
    }    

    var startingLevel = locations.every(x => x.locationGroupId == null) ? -1 : 0;

    return (
        <Select value={locationId} fullWidth onChange={(e) => handleLocationChange(e.target.value)}>
            <MenuItem key={null} value={null}>Not set</MenuItem>
            {groupEntries(null, startingLevel)}
            {groups.map(g => groupEntries(g, 0))}
        </Select>
    );
}

export default LocationSelect;